module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkBAMAAAATLoWrAAAAHlBMVEUAAAAwMFAqOlotOVgtOVkuOlktOlguOlkuOVguOlnzRUtgAAAACXRSTlMAEDC/wM/Q7/BiyZD8AAAAtElEQVQoz13SLRLCMBiE4W1O0Bl+dF1rOQKyEolEYnGxdfUFurdFfGm6S2TmEdl3Ahw6yEkXoLm/9Kp/tzjxKyxl3jCSwnpywUBhKZMT0iysJ9cOygJBWUHCNiSsosp2VJmgwhQVZiiYoWCOgIF0FMwRUqZ1i4dbt0B/rCfX2VjK5GR5Y53lLeuUlXXCaoKd1QSVSaeNSafCLGYwixlstE4DueBsndLMB5qnxRw+LXD0j3nFD9tUgQgK5yK4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/close.png
// module id = q6Jf
// module chunks = 21